import React, { useState, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import { useNavigate, useLocation } from "react-router-dom";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../shared/HelpModal";
import HelpContext from "../shared/context/HelpProvider";
import SearchableDropdownMulti from "../shared/SearchableDropdownMulti";
const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({ increment, counter, meeting, roles, members }) {
  const [title, setTitle] = useState(""); // useState hook
  const [error, setError] = useState(false);
  const [memberValue, setMemberValue] = useState("");
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const toDay = new Date();
  const currentDate =
    toDay.getFullYear() +
    "-" +
    ("0" + (toDay.getMonth() + 1)).substr(-2) +
    "-" +
    ("0" + toDay.getDate()).substr(-2);
  const timeS =
    ("0" + toDay.getHours()).substr(-2) +
    ":" +
    ("0" + toDay.getMinutes()).substr(-2);
  const [newMem, setNewMem] = useState({
    attend: false,
    send_date: currentDate,
    bhina_meeting: meeting.id,
    memberlist: null,
    role: null,
    notes: null,
  });

  const handleDDSChange = (e) => {
    e.preventDefault();

    const n = Number(e.target.value);
    const name = e.target.name;

    setNewMem((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };

  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;

    setNewMem((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChangeMember = (id, val) => {
    // Find the selected member from the members list
    setNewMem((prevState) => ({
      ...prevState,
      memberlist: id,
    }));
    const selectedMember = members.find((member) => member.id === id);

    if (selectedMember) {
      // Convert nazeegType to an integer, or default to 0 if not valid
      const nazeegTypeAsInt = parseInt(selectedMember.nazeegType, 10) || 0;

      // Update newMem.role to the integer version of nazeegType
      setNewMem((prevState) => ({
        ...prevState,
        role: nazeegTypeAsInt,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "bhinamember/",
          newMem,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
    setTitle("");
    setError(false);
  };

  // render

  return (
    <div>
      <HelpModal />
      <center>
        <div className="card text-dark bg-light container p-3  border">
          <div className="card-header">
            <h3
              onClick={() => {
                setSaeef("23-24");
                setShowHelp(true);
              }}
            >
              חברי הוועדה של הישיבה: {meeting.mt_num}
              <span className="help">
                <MdLiveHelp />
              </span>
            </h3>
          </div>

          <div className="card-body ">
            <Row className="mt-4 justify-content-center">
              <Col sm="8" md={{ size: 3, offset: 1 }}>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group ">
                    <Row>
                      <Col>בחירת חבר: </Col>
                      <Col sm="8" md={{ size: 3, offset: 0 }}>
                        <SearchableDropdownMulti
                          options={members}
                          label="first_name"
                          label2="last_name"
                          label3="ignore"
                          id="id"
                          other="last_name "
                          selectedVal={memberValue}
                          handleChange={(val, id) => {
                            setMemberValue(val);
                            handleChangeMember(id, val);
                          }}
                          //handleChange={handleDDSChange}
                          inputProps={{ autocomplete: "off" }}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="role"
                      style={{ marginRight: ".5rem", marginLeft: ".5rem" }}
                    >
                      בחירת תפקיד בוועדה:
                    </label>

                    <select
                      name="role"
                      onChange={handleDDSChange}
                      value={newMem.role}
                    >
                      <option value="" selected>
                        בחר תפקיד
                      </option>
                      {roles?.map((o) => (
                        <option key={o.id} value={o.id}>
                          {o.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <br></br>
                  <div className="form-group">
                    <label htmlFor="send_date">מועד שליחת ההדועה</label>
                    <input
                      type="date"
                      name="send_date"
                      value={newMem.send_date}
                      onChange={handleChange}
                      className="form-control"
                      id="send_date"
                      placeholder="22-8-2022"
                    />
                  </div>
                  <label htmlFor="notes">הערות </label>
                  <textarea
                    name="notes"
                    value={newMem.notes}
                    onChange={handleChange}
                    className="form-control"
                    id="notes"
                  />
                  <br />
                  <button type="submit" className="btn btn-primary">
                    אישור הוספת חבר חדש
                  </button>
                </form>
              </Col>
            </Row>
          </div>
        </div>
      </center>
    </div>
  );
}
